import { ErrorBoundary } from '@common/components/feedback/ErrorBoundary';
import { isDev } from '@config/env';
import i18n from '@config/i18n';
import { queryClient } from '@config/queryClient';
import { ToastProvider } from '@ntconsult/aluma-react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import type { ReactNode } from 'react';
import { I18nextProvider } from 'react-i18next';

export function Providers({ children }: { children: ReactNode }) {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <I18nextProvider i18n={i18n}>
          <ToastProvider>{children}</ToastProvider>
        </I18nextProvider>
        {isDev && <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" />}
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
